document.addEventListener('DOMContentLoaded', () => {
    const buttonShowWin = document.querySelectorAll('.winner__button');
    const popUpWithNumber = document.querySelectorAll('.popUp');
    const closeButton = document.querySelectorAll('.popUp__close');

    for (let i = 0; i < buttonShowWin.length; i++) {
        buttonShowWin[i].addEventListener('click', function () {
            popUpWithNumber[i].classList.add('show')
        })
    }

    for (let i = 0; i < buttonShowWin.length; i++) {
        closeButton[i].addEventListener('click', function () {
            popUpWithNumber[i].classList.remove('show')
        })
    }

    const checkCode = document.querySelectorAll('.winner__input-code-search');
    const inputCheckCode = document.querySelectorAll('.winner__input-code input');

    for (let i = 0; i < checkCode.length; i++) {

        checkCode[i].addEventListener('click', async function () {
            inputCheckCode[i].value

            const data = new FormData();
            data.append('action', 'check_code')
            data.append('number', inputCheckCode[i].value)
            data.append('postId', inputCheckCode[i].dataset.post_id)

            const response = await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: data,
            });

            const result = await response.json();

            switch (result.status) {
                case 'first_win' :
                    showWinPopUp('ВІТАЄМО!', 'ВАШ КОД ВИГРАШНИЙ', '0', true)
                    inputCheckCode[i].value = '';
                    break;
                case 'second_win' :
                    showWinPopUp('ВІТАЄМО!', 'ВАШ КОД ВИГРАШНИЙ', '1', true)
                    inputCheckCode[i].value = '';
                    break;
                case 'third_win' :
                    showWinPopUp('ВІТАЄМО!', 'ВАШ КОД ВИГРАШНИЙ', '2',true)
                    inputCheckCode[i].value = '';
                    break;
                default:
                    showWinPopUp('Нажаль', 'сьогодні ваш номер нічого не виграв', null, false)
                    inputCheckCode[i].value = '';
            }
        })

    }

    function showWinPopUp(title, descr, numPrize, win) {
        let popUp = document.querySelector('.popUpCheckNum');
        let popUpContent = document.querySelector('.popUpCheckNum__content');
        let popUpTitle = popUp.querySelector('h2');
        let popUpDescription = popUp.querySelector('p');
        let popUpImgPrize = popUp.querySelectorAll('.popUpCheckNum__photo-prize');
        let closeButton = popUp.querySelector('.popUpCheckNum__close');

        popUpTitle.innerHTML = title;
        popUpDescription.innerHTML = descr;

        for (let i = 0; i < popUpImgPrize.length; i++) {
            popUpImgPrize[i].style.display = 'none';
        }
        if (numPrize) {
            popUpImgPrize[numPrize].style.display = 'block';
        }

        if(win){
            popUpContent.classList.add('win')
        } else if (popUpContent.classList.contains('win')){
            popUpContent.classList.remove('win')
        }

        closeButton.addEventListener('click', function () {
            popUp.classList.remove('show');
        })

        popUp.classList.add('show');
    }


})